var _rect, _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.75,
    y: 3.75,
    width: 14.5,
    height: 13.5,
    rx: 1.25,
    stroke: "#AEB7BC",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 8H17",
    stroke: "#AEB7BC",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 2V5.5",
    stroke: "#AEB7BC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2V5.5",
    stroke: "#AEB7BC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 11,
    r: 1,
    fill: "#AEB7BC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 14,
    r: 1,
    fill: "#AEB7BC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 11,
    r: 1,
    fill: "#AEB7BC"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 14,
    r: 1,
    fill: "#AEB7BC"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 11,
    r: 1,
    fill: "#AEB7BC"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 14,
    r: 1,
    fill: "#AEB7BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarWhite);
export default __webpack_public_path__ + "static/media/calendarWhite.dc014ad0e6310d80228bb476291ab292.svg";
export { ForwardRef as ReactComponent };